import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const change_html_font_size = () => {
  let valid_width = Math.min(window.screen.availWidth, 600);
  document.documentElement.style.fontSize = (valid_width / 600) * 12+'px'
}
change_html_font_size();
window.onload = change_html_font_size;
// 页面宽度发生变化时onresize 
// 1920设计图的width
window.onresize = change_html_font_size;


ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

